export const SLOT_EVENT_DETAILS_HEADER = 'header'
export const SLOT_EVENT_DETAILS_CONTENT = 'details'
